import React, { useEffect, useRef, useState } from 'react';
import SelectBox from '../../../../common/CustomSelectBox';
import { makeStyles } from '@material-ui/core/styles';
import Form from '../../../form/Form';
import { CodeTemplates, TemplatesAvaliableWithClosedCase} from '../../../../../Constantes/codeDocumentationTemplates';
import { CaseStates } from '../../../../../Constantes/CaseStates';
import { validateClaimsData, validateDeliveryData, validateDocumentationData, validateDocumentationDraft, validateFailedItvFormData, validateFuelCardFormData, validateInformationFields, validateItvFormData, validateLetterFormData, validateMarshFormData, validateOvcFormData, validateSubstitutioVehicleDraft, validateSubstitutionData, validateTerminationsData, validateWorkshopAppointmentData } from '../../formValidationFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { selectContract } from '../../../../../redux/contract/selectors';
import { selectCurrentCase } from "../../../../../redux/currentCase/selectors";
import { setFormAppointmentProperty, setFormAppointment , setFormDocumentationProperty, setFormDocumentation, setFormClaimsProperty, setFormClaims, setFormInformationProperty, setFormInformation, setFormTerminationsProperty, setFormTerminations, setFormSubstitutionVehicle, setFormSubstitutionVehicleProperty, setFormDelivery, setFormDeliveryProperty, setFormOther, setFormOvcProperty, setFormOvc, setFormItv, setFormItvProperty, setFormFuelCard, setFormFuelCardProperty, setFormMarsh, setFormMarshProperty, setFormLetterQueryProperty, setFormLetterQuery, setFormResidentCardProperty, setFormResidentCard} from "../../../../../redux/caseForms/caseFormSlice"
import { openModal } from '../../../../../redux/modal/modalSlice';
import { errorHandler } from '../../../../../commonFunctions/errorHandler';
import saveAs from 'file-saver';
import { updateContractData } from '../../../../../redux/contract/thunks';
import { convertToLocalTime, getClaimsRequestFormData, _base64ToArrayBuffer } from '../../../../../commonFunctions/commonFunctions';
import { baseRequest } from '../../../../../fetch/basicThunk';
import { QUERY_POST_GENERATE_DOC } from '../../../../../fetch/constantQueries';
import dayjs from "dayjs";
import { updateExceptionChecked } from '../../../../../redux/contract/contractSlice';
import { selectCallId } from '../../../../../redux/appState/selectors';
import { setClaims, setDelivery, setDocumentation, setFuelCard, setItv, setLetter, setLetterQuery, setMarsh, setOvc, setSubstitutionVehicle, setTerminations, setWorkshopAppointment } from '../../../../../redux/currentCase/thunks';
import {selectFormAppointment , selectFormDocumentation , selectFormClaims, selectFormInformation, selectFormTerminations, selectFormSubstitutionVehicle , selectFormDelivery , selectFormOvc, selectFormItv, selectFormFuelCard, selectFormMarsh, selectFormLetterQuery, selectFormResidentCard} from "../../../../../redux/caseForms/selectors"
import { selectDocumentationTemplates } from '../../../../../redux/documentationTemplates/selectors';
import { getDocumentationTemplate } from '../../../../../redux/documentationTemplates/thunks';
import { getFactoryCasesByPlate } from '../../../../../redux/factoryCases/thunks';
import { selectITVBondInfo } from '../../../../../redux/factoryItvBond/selectors';
import { SubstitutionVehicleCodes } from '../../../../../Constantes/substitutionVehicleCodes';
import { selectFactoryOfficesByCity, selectFactoryOfficesByProvince } from '../../../../../redux/factoryOffices/selectors';
import { selectFactoryProvinces, selectFactoryProvincesWithOffices } from '../../../../../redux/factoryProvinces/selectors';
import { selectFactoryRentTypes } from '../../../../../redux/factoryRentTypes/selectors';
import { selectFactoryChannels } from '../../../../../redux/factoryChannels/selectors';
import { selectFactoryCategories } from '../../../../../redux/factoryCategories/selectors';
import { selectFactoryTypes } from '../../../../../redux/factoryTypes/selectors';
import { selectFactoryRates } from '../../../../../redux/factoryRates/selectors';
import { selectFactoryBranches } from '../../../../../redux/factoryBranches/selectors';
import { selectFactoryCities } from '../../../../../redux/factoryCities/selectors';
import { selectWorkshopSearchResults } from '../../../../../redux/workshopSearch/selectors';
import { PanelDialogue } from '../../../../common/PanelDialogue';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({

    label: {
        color: "#eeeeee"
    },
    controlers: {
        width:"100% !important"
    },
    containers: {
       display: "flex",
       flexDirection: "column",
       rowGap: "1rem",
       maxHeight: "calc(100vh - 24rem)",
       overflowY: "auto"
    },
    hideDocumentationContainer: {
        display:"none"
    },
    form_wrapper: {
        overflowY: "auto",
        maxHeight: "inherit",
        ["&::-webkit-scrollbar"]: {
            width: "0.625rem",
            height: "0.625rem"
          },
        ["&::-webkit-scrollbar-track"]: {
            background: "#9cbddb"
          },
        ["&::-webkit-scrollbar-thumb"]: {
            background: "#2271b5"
        },
        ["&::-webkit-scrollbar-thumb:hover"]: {
            background: "#2271b5"
          }
    },
    input_grid: {
        display: "grid",
        columnGap: 10,
        gridTemplateColumns: "1fr 1fr"
    },
    custom_item:{
        position: "relative",  
        minHeight: 30,  
        whiteSpace: "normal",  
        // overflow: "hidden",  
        textOverflow: "ellipsis"
    },
    custom_item_factory:{
        position: "relative",  
        minHeight: "min-content",  
        whiteSpace: "normal",  
        overflow: "hidden",  
        textOverflow: "ellipsis"
    },
    branch_wrapper:{
      background: "#e0e2e5",
      borderBottom: "1px solid #000",
      padding: "15px 16px 14px",
      boxSizing: "border-box",
      minHeight: "3rem"
    },
    branch_wrapper_disabled:{
      background: "#e0e2e5",
      borderBottom: "1px solid #000",
      padding: "15px 16px 14px",
      boxSizing: "border-box",
      minHeight: "3rem"
    }
  });

  
export default function DocumentationForm (props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const anchorEl = document.getElementById("template-button")
    const {showDocumentation,handleShowForms, disabledButtom, setAllButtonsToState, setDisabledButtom, setDataSms, phoneNumber, setDataEmailForm} = props;
    const [templateOptions, setTemplateOptions] = useState(documentationTemplates);
    const documentationTemplates = useSelector(selectDocumentationTemplates);
    const itvBondInfo = useSelector(selectITVBondInfo);
    const templateCombo = useRef(null);
    const callId = useSelector(selectCallId)
    const [formType,setFormType] = useState("");
    const dispatch = useDispatch();
    const contract = useSelector(selectContract)
    const currentCase = useSelector(selectCurrentCase)
    const workshopSearch = useSelector(selectWorkshopSearchResults)

    const [dataForm,setDataForm] = useState({});
    const [names,setNames]=useState(null);

    const [dataDocumentation,setDataDocumentation] = useState({
        template: null,
        plate:contract.plate != null ? contract.plate : "",
    })

    const dataFormAppointment = useSelector(selectFormAppointment)
    const dataFormDocumentation = useSelector(selectFormDocumentation)
    const dataFormClaims = useSelector(selectFormClaims);
    const dataFormInformation = useSelector(selectFormInformation);
    const dataFormTerminations = useSelector(selectFormTerminations);
    const dataFormSubstitutionVehicle = useSelector(selectFormSubstitutionVehicle);
    const dataFormDelivery = useSelector(selectFormDelivery);
    const dataFormOvc = useSelector(selectFormOvc);
    const dataFormItv = useSelector(selectFormItv);
    const dataFormFuelCard = useSelector(selectFormFuelCard);
    const dataFormMarsh = useSelector(selectFormMarsh);
    const officesByCity = useSelector(selectFactoryOfficesByCity);
    const dataFormLetterQuery = useSelector(selectFormLetterQuery);
    const dataFormResidentCard = useSelector(selectFormResidentCard);
    const provincesWithOffices = useSelector(selectFactoryProvincesWithOffices);
    const allProvinces = useSelector(selectFactoryProvinces);
    const allCities = useSelector(selectFactoryCities);
    const cities = useSelector(selectFactoryOfficesByProvince);
    const rentTypes = useSelector(selectFactoryRentTypes)
    const channels = useSelector(selectFactoryChannels)
    const categories = useSelector(selectFactoryCategories)
    const typesInfo = useSelector(selectFactoryTypes)
    const rates = useSelector(selectFactoryRates)
    const branches = useSelector(selectFactoryBranches)

function handleSetDataFormAppointment(main,value){
    dispatch(setFormAppointmentProperty({main,value}))
  }
  function handleSetDataFormDocumentation(main,value){
    dispatch(setFormDocumentationProperty({main,value}))
  }
  
  function handleSetDataFormClaims(main,value){
    dispatch(setFormClaimsProperty({main, value}));
  }
  
  function handleSetDataFormDelivery(main,value){
    dispatch(setFormDeliveryProperty({main, value}));
  }
  
  function handleSetDataFormInformation(main,value){
    dispatch(setFormInformationProperty({main,value}))
  }
  
  function handleSetDataFormTerminations(main,value){
    dispatch(setFormTerminationsProperty({main,value}))
  }
  
  function handleSetDataFormSubstitutionVehicle(main,value){
    dispatch(setFormSubstitutionVehicleProperty({main,value}))
  }

  function handleSetDataFormOvc(main, value){
    dispatch(setFormOvcProperty({main,value}))
  }
  
  function handleSetDataFormItv(main, value){
    dispatch(setFormItvProperty({main,value}))
  }

  function handleSetDataFormFuelCard(main, value){
    dispatch(setFormFuelCardProperty({main,value}))
  }

  function handleSetDataFormMarsh(main, value){
    dispatch(setFormMarshProperty({main,value}))
  }

  function handleSetDataFormLetterQuery(main, value){
    dispatch(setFormLetterQueryProperty({main,value}))
  }

  function handleSetDataFormResidentCard(main, value){
    dispatch(setFormResidentCardProperty({main,value}))
  }

function getDataForm(){
    switch(dataDocumentation?.template?.code){
      case CodeTemplates.WORKSHOP_APPOINTMENT: return dataFormAppointment;
      case CodeTemplates.DOCUMENTATION_REQUEST: return dataFormDocumentation;
      case CodeTemplates.INFORMATION: return dataFormInformation;
      case CodeTemplates.TERMINATIONS: return dataFormTerminations;
      case CodeTemplates.SUBSTITUTION_VEHICLE: return dataFormSubstitutionVehicle;
      case CodeTemplates.CLAIMS: return dataFormClaims;
      case CodeTemplates.DELIVERY: return dataFormDelivery;
      case CodeTemplates.OVC: return dataFormOvc;
      case CodeTemplates.FAILED_ITV: return dataFormItv;
      case CodeTemplates.FUEL_CARD: return dataFormFuelCard;
      case CodeTemplates.MARSH_ASSISTANCE: return dataFormMarsh;
      case CodeTemplates.LETTER_QUERY: return dataFormLetterQuery;
      case CodeTemplates.RESIDENT_CARD_LETTER: return dataFormResidentCard;
      default : return dataForm
    }
  }

function getSetterPropertyDataForm(){
    switch(dataDocumentation?.template?.code){
      case CodeTemplates.WORKSHOP_APPOINTMENT: return handleSetDataFormAppointment;
      case CodeTemplates.DOCUMENTATION_REQUEST: return handleSetDataFormDocumentation;
      case CodeTemplates.INFORMATION: return handleSetDataFormInformation;
      case CodeTemplates.TERMINATIONS: return handleSetDataFormTerminations;
      case CodeTemplates.SUBSTITUTION_VEHICLE: return handleSetDataFormSubstitutionVehicle;
      case CodeTemplates.CLAIMS: return handleSetDataFormClaims;
      case CodeTemplates.DELIVERY: return handleSetDataFormDelivery;
      case CodeTemplates.FAILED_ITV: return handleSetDataFormItv;
      case CodeTemplates.OVC: return handleSetDataFormOvc;
      case CodeTemplates.FUEL_CARD: return handleSetDataFormFuelCard;
      case CodeTemplates.MARSH_ASSISTANCE: return handleSetDataFormMarsh;
      case CodeTemplates.LETTER_QUERY: return handleSetDataFormLetterQuery;
      case CodeTemplates.RESIDENT_CARD_LETTER: return handleSetDataFormResidentCard;
      default : return setDataForm
    }
  }
  
function getSubmitFunction(){
    switch(dataDocumentation?.template?.code){
      case CodeTemplates.WORKSHOP_APPOINTMENT: return handleAppointmentSubmit;
      case CodeTemplates.DOCUMENTATION_REQUEST: return handleDocumentationRequestSubmit;
      case CodeTemplates.INFORMATION: return handleInformationRequestSubmit;
      case CodeTemplates.TERMINATIONS: return handleTerminationsRequestSubmit;
      case CodeTemplates.SUBSTITUTION_VEHICLE: return handleSubstitutionVehicleRequestSubmit;
      case CodeTemplates.CLAIMS: return handleClaimsSubmit;
      case CodeTemplates.DELIVERY: return handleDeliveryRequestSubmit;
      case CodeTemplates.OVC : return handleOvcSubmit;
      case CodeTemplates.FAILED_ITV : return handleItvSubmit;
      case CodeTemplates.FUEL_CARD : return handleFuelCardSubmit;
      case CodeTemplates.MARSH_ASSISTANCE: return handleMarshSubmit;
      case CodeTemplates.LETTER_QUERY: return handleLetterQuerySubmit;
      case CodeTemplates.RESIDENT_CARD_LETTER: return handleDocumentationRequestSubmit;
      default : return handleDocumentationSubmit
    }
  }


async function handleSubmit(dataDoct, validateFunction, submitFunction, formSetterFunction, isDraft, validateDraft = false){
  setAllButtonsToState({disabled: true})
  if(!dataDoct.templateId){
    dispatch(openModal({type: "warning", message: "Debe seleccionar una tipología"}))
    setAllButtonsToState({disabled: false})
    return
  }

  if(!currentCase.entryChannelId || currentCase.entryChannelId === ""){
    dispatch(openModal({type: "warning", message: `Debe especificar el Canal de Entrada`}))
    setAllButtonsToState({disabled: false})
    return
  };

  const {code: templateCode} = templateOptions.filter(templateOption => dataDoct.templateId === templateOption.id)

  if(!isDraft || validateDraft){
    if(!validateFunction(dataDoct, dispatch, templateCode, contract)){
      setAllButtonsToState({disabled: false})
      return
    }
  }


  if( !contract?.unassigned && contract?.exceptions.length > 0 && !contract?.checkedExceptions){
    dispatch(openModal({ type: "warning", message:"Por favor, marque que ha leído las exceções"}))
    setAllButtonsToState({disabled: false})
    return
  }
  const submitData = {
    ...dataDoct, 
    caseId: currentCase.caseId,
    plate: contract.plate,
    brand: contract.brand,
    model: contract.model,
    entryChannelId: currentCase.entryChannelId,
    template:dataDocumentation.template,
    callId: callId,
    isDraft: isDraft,
    emails: dataDoct.sendMail ? dataDoct.emails?.split(";") ?? null : null,
    workshopSearchResult : workshopSearch
  }
 
  const data = await dispatch(submitFunction({body: submitData}))

  if(data.payload){
      updatePauData(dataDoct);
      dispatch(formSetterFunction({}))
      dispatch(getFactoryCasesByPlate({query: `?plate=${contract.plate}`}))
      setDataDocumentation(prevState => ({
        ...prevState,
        template: null
      }));
  }

  if(currentCase.stateId === CaseStates.CLOSED || currentCase.stateId === CaseStates.FACTORY_PROCESS || currentCase.stateId === CaseStates.FACTORY_PROCESS_RETURN){
    setDisabledButtom(prevState=>({...prevState, documentation: true, messageForm: false}))
  }  else {
    setAllButtonsToState({disabled: false})
    setDisabledButtom(prevState=>({...prevState, documentation: false, messageForm: false, advanceFactoryCase: true}))
  }

  dispatch(updateExceptionChecked(false))

}


async function handleAppointmentSubmit(dataDoct, arrayName, isDraft){

  const submitData = {...dataDoct}
  submitData.option1 = convertToLocalTime(submitData.option1);

  if(submitData.option2) 
    {submitData.option2 = convertToLocalTime(submitData.option2)};
  
  if(submitData.kilometers){
    submitData.kilometers = submitData.kilometers.toString();
  }

  await handleSubmit(submitData, validateWorkshopAppointmentData, setWorkshopAppointment, setFormAppointment, isDraft)

}

async function handleDocumentationRequestSubmit(dataDoct, arrayName, isDraft){
 
  const submitData={...dataDoct,
  nextITVDate : itvBondInfo?.nextITVDate ?? "",
  lastITVDate : itvBondInfo?.lastITVDate ?? "",
  lastSentBond : itvBondInfo?.lastSentBond ?? "",
  registrationDate : itvBondInfo?.registrationDate ?? ""
  }

  const validateFunction = isDraft? validateDocumentationDraft : validateDocumentationData;

  await handleSubmit(submitData, validateFunction, setDocumentation, setFormDocumentation, isDraft, true)

}

async function handleClaimsSubmit(dataDoc, arrayName, isDraft){
 
  const dataForm = getClaimsRequestFormData(dataDoc, dataDocumentation.template.code);

  const submitData = {
    templateId: dataForm.templateId,
    ...dataDoc
  }

  await handleSubmit(submitData, validateClaimsData, setClaims, setFormClaims, isDraft)
  
}

async function handleInformationRequestSubmit(dataDoct, arrayName, isDraft){

  await handleSubmit(dataDoct, validateInformationFields, setDocumentation, setFormDocumentation, isDraft)
  
}

async function handleTerminationsRequestSubmit(dataDoct, arrayName, isDraft){

  const setFunction = dataDoct.subType === "renting_own_insurance_mtr" ? setSubstitutionVehicle : setTerminations;
  const submitData = {
    ...dataDoct
  }


  if(dataDoct.subType === "renting_own_insurance_mtr"){
    submitData.idCity = allCities.find(city=> city.description === submitData.city)?.id;
    submitData.idProvince = allProvinces.find(province=> province.description === submitData.province)?.id;
    submitData.channelId = channels.find(channel=> channel.description === submitData.channel)?.id || "1";
    submitData.clientCode = contract.customerCode;
    
    if(submitData.mtrType === "Renting Flexible")
      submitData.returnPlate = contract.plate 
  }

  await handleSubmit(submitData, validateTerminationsData, setFunction, setFormTerminations, isDraft)

}

async function handleDeliveryRequestSubmit(dataDoct, arrayName, isDraft){

  await handleSubmit(dataDoct, validateDeliveryData, setDelivery, setFormDelivery, isDraft)

}

async function handleSubstitutionVehicleRequestSubmit(dataDoct, arrayName, isDraft){
  const submitData = {
    ...dataDoct
  }

  if(submitData.templateCode === SubstitutionVehicleCodes.SUBSTITUTION_VEHICLE && (submitData.office && submitData.office?.trim() !== "")){
    const office = officesByCity.find(x => x.officeInfo.officeName === submitData.office);

    submitData.weekdaySchedule = office?.officeInfo?.weekdaySchedule ?? "";
    submitData.saturdaySchedule = office?.officeInfo?.saturdaySchedule ?? "";
    submitData.sundaySchedule = office?.officeInfo?.sundaySchedule ?? "";

    submitData.idOffice = office.id;

    submitData.idRentType = rentTypes.find(type=> type.description === submitData.rentType)?.id;
    submitData.idShortAdvance = typesInfo.find(type=> type.description === submitData.typeInfo)?.id;
    submitData.idCategory = categories.find(category=> category.description === submitData.category)?.id;
    submitData.channelId = channels.find(channel=> channel.description === submitData.channel)?.id || "1";
    submitData.branchId = branches.find(branch => branch.description === submitData.branch)?.id;
    submitData.idCity = cities.find(city=> city.description === submitData.city)?.id;
    submitData.idProvince = provincesWithOffices.find(province=> province.description === submitData.province)?.id;
    submitData.clientCode = contract.customerCode;
  }

  if(submitData.templateCode === SubstitutionVehicleCodes.SUBSTITUTION_VEHICLE_RETURN){
    submitData.idCity = allCities.find(city=> city.description === submitData.city)?.id;
    submitData.idProvince = provincesWithOffices.find(province=> province.description === submitData.province)?.id;
    submitData.clientCode = contract.customerCode; 
    submitData.PickDate = currentCase.caseId === 0 ? convertToLocalTime(dayjs(new Date()).startOf("day")) : currentCase.creationDate;
  }
  
  const validateFunction = validateSubstitutionData;

  await handleSubmit(submitData, validateFunction, setSubstitutionVehicle, setFormSubstitutionVehicle, isDraft)

}

  async function updatePauData(dataDoct){
  const contractHasPauData = contract.contractData? true: false;
  const hasNewEmail = contractHasPauData && dataDoct.email && dataDoct.email.trim() !== contract.contractData?.email;
  const hasNewName = contractHasPauData && dataDoct.name && dataDoct.name.trim() !== contract.contractData?.userName;
  const hasNewSurname =  contractHasPauData && dataDoct.surname && dataDoct.surname.trim() !== contract.contractData?.userSurnames;
  const hasNewMobilePhone = contractHasPauData && dataDoct.phoneNumber && dataDoct.phoneNumber.trim() !== contract.contractData?.mobilePhone
  const hasNewDNI = contractHasPauData && dataDoct.dni && dataDoct.dni.trim() !== contract.contractData?.licenseNumber


  const hasNewValues = hasNewEmail || hasNewName || hasNewSurname || hasNewMobilePhone || hasNewDNI;

   if(!contractHasPauData || hasNewValues){

     const submitData = {
      contractDataId: contract.contractData?.contractDataId,
      userName: hasNewName || !contractHasPauData? dataDoct.name : contract.contractData?.userName,
      userSurnames: hasNewSurname || !contractHasPauData? dataDoct.surname : contract.contractData?.userSurnames,
      mobilePhone: hasNewMobilePhone || !contractHasPauData? dataDoct.phoneNumber : contract.contractData?.mobilePhone,
      phone:contract.contractData?.phone,
      email: hasNewEmail || !contractHasPauData? dataDoct.email : contract.contractData?.email,
      driversClub: contract.contractData?.driversClub,
      driversClubDate: contract.contractData?.driversClubDate? dayjs(contract.contractData?.driversClubDate,"DD/MM/YYYY").format("YYYY/MM/DD") : null,
      kilometrage: contract.contractData?.kilometrage,
      licenseNumber: hasNewDNI || !contractHasPauData? dataDoct.dni: contract.contractData?.licenseNumber
     }

     await dispatch(updateContractData({param: contract.id, body: submitData}))
    }
  }


async function handleOvcSubmit(dataDoc, arrayName, isDraft){

  await handleSubmit(dataDoc, validateOvcFormData, setOvc, setFormOvc, isDraft)
  
}

async function handleItvSubmit(dataDoc, arrayName, isDraft){

await handleSubmit(dataDoc, validateFailedItvFormData, setItv, setFormItv, isDraft)

}


async function handleDocumentationSubmit (dataDoc, arrayName, isDraft) {
    setAllButtonsToState({disabled: true})
  
    if(!currentCase.entryChannelId || currentCase.entryChannelId === ""){
      dispatch(openModal({type: "warning", message: `Debe especificar el Canal de Entrada`}))
      setAllButtonsToState({disabled: false})
      return
    };

    if( !contract?.unassigned && contract?.exceptions.length > 0 && !contract?.checkedExceptions){
      dispatch(openModal({ type: "warning", message:"Por favor, marque que ha leído las exceções"}))
      setAllButtonsToState({disabled: false})
      return
    }
    if (dataDocumentation != null) {

      let submitData = {...dataDoc, caseId: currentCase.caseId,
                                    brand: contract.brand,
                                    model: contract.model,
                                    caseStateId: currentCase.stateId,
                                    entryChannelId: currentCase.entryChannelId,
                                    subType: dataDoc.subType.code,
                                    isDraft
                                  };

      submitData.plate = contract.unassigned? null : contract.plate;
      submitData.template = dataDocumentation.template;
      submitData.templateName = dataDocumentation.template.name;
      submitData.templateId =  dataDocumentation.template.id;
      submitData.templateCode = dataDocumentation.template.code;
      
      submitData.caseId = currentCase.caseId;

      if(!isDraft){
        if(!validateLetterFormData(submitData, dispatch)){
          setAllButtonsToState({disabled: false})
          return
        }
              
    }
      const response = await dispatch(setLetter({body: submitData}))
      if(response.payload){
        const mustSendLetter = !isDraft && !dataDoc.subType.factoryDisabled

        if(mustSendLetter){
          
          try {
            const data = await baseRequest({body: submitData}, dispatch, QUERY_POST_GENERATE_DOC, "POST");
            if (data) {
                dispatch(openModal({ type: "warning", message:"Error enviando correo electrónico"}));
                saveAs(new Blob([ _base64ToArrayBuffer(data)], { type: 'application/pdf' }), dataDocumentation.template.name+'.pdf');
            } else{
                dispatch(openModal({ type: "success", message:"Correo electrónico enviado"}));
                await updatePauData(submitData)
            }
          } catch (error) {
              dispatch(openModal(errorHandler(error)))
          }  
        }

        updatePauData(dataDoc);
        dispatch(getFactoryCasesByPlate({query: `?plate=${contract.plate}`}))
        setDataDocumentation(prevState => ({
          ...prevState,
          template: null
        }));
    }
    }
    setAllButtonsToState({disabled: false})
  }


async function handleFuelCardSubmit(dataDoc, arrayName, isDraft){

  await handleSubmit(dataDoc, validateFuelCardFormData, setFuelCard, setFormFuelCard, isDraft)
  
} 

async function handleMarshSubmit(dataDoc, arrayName, isDraft){

  await handleSubmit(dataDoc, validateMarshFormData, setMarsh, setFormMarsh, isDraft)

}

  async function handleLetterQuerySubmit(dataDoc, arrayName, isDraft){

    setAllButtonsToState({disabled: true})
  
    if( !contract?.unassigned && contract?.exceptions.length > 0 && !contract?.checkedExceptions){
      dispatch(openModal({ type: "warning", message:"Por favor, marque que ha leído las exceções"}))
      setAllButtonsToState({disabled: false})
      return
    }
  
    const submitData = {
      ...dataDoc, 
      caseId: currentCase.caseId,
      plate: contract.plate,
      brand: contract.brand,
      model: contract.model,
      entryChannelId: currentCase.entryChannelId,
      template:dataDocumentation.template,
      callId: callId,
      isDraft
    }
    const data = await dispatch(setLetterQuery({body: submitData}))
    if(data.payload){
        dispatch(setFormLetterQuery({}))
        setDataDocumentation(prevState => ({
          ...prevState,
          template: null
        }));
    }
    setAllButtonsToState({disabled: false})
    if(currentCase.stateId === CaseStates.CLOSED){
      setDisabledButtom({documentation: true})
    }  
    dispatch(updateExceptionChecked(false))
  }

// Gestiona el cambio de plantilla

  function handleTemplateChange (e) {
 
    const preloadedPhoneNumber = contract.contractData?.mobilePhone || phoneNumber; 

    let preloadedFields= {
      mtr : false,
      email: contract.contractData?.email? contract.contractData.email : "",
      name: contract.contractData?.userName? contract.contractData.userName : "",
      surname: contract.contractData?.userSurnames? contract.contractData.userSurnames : "",
      dni: contract.contractData? contract.contractData?.licenseNumber : "",
      phoneNumber : preloadedPhoneNumber
    }
    if(e?.code === "workshop_appointment"){
      
      if(contract.unassigned || !contract.plate){
        dispatch(openModal({type: "warning", message: "Para utilizar esta plantilla debe asignar una matrícula al caso."}))
        setDataForm({});
        dispatch(setFormAppointment({}));
        dispatch(setFormDocumentation({}));
        dispatch(setFormClaims({}));
        dispatch(setFormInformation({}));
        dispatch(setFormTerminations({}));
        dispatch(setFormSubstitutionVehicle({}));
        dispatch(setFormDelivery({}));
        dispatch(setFormOther({}));
        dispatch(setFormOvc({}));
        dispatch(setFormItv({}));
        dispatch(setFormResidentCard({}))

        setDataDocumentation(prevState => ({
          ...prevState,
          template: null
        }));
        return
      }

      preloadedFields = {...preloadedFields,
        name: contract.contractData?.userName || "",
        surname : contract.contractData?.userSurnames || "",
        phoneNumber: preloadedPhoneNumber,
        orangeLightPilot: false,
        itvBonus: false,
        originalDocItv: false,
        numberOfTyres:2,
        tyrePosition: "Delantero",
        backOffice: false,
        sendMail: false
      }
    }
    setDataForm(preloadedFields);

    const preloadedFieldsWorkshopAppointment = {
      email: dataFormAppointment?.email &&  dataFormAppointment?.email != "" ? dataFormAppointment?.email : contract.contractData?.email? contract.contractData.email : "",
      name: dataFormAppointment?.name &&  dataFormAppointment?.name != "" ? dataFormAppointment?.name :  contract.contractData?.userName || "",
      surname : dataFormAppointment?.surname &&  dataFormAppointment?.surname != "" ? dataFormAppointment?.surname : contract.contractData?.userSurnames || "",
      phoneNumber:  dataFormAppointment?.phoneNumber &&  dataFormAppointment?.phoneNumber != "" ? dataFormAppointment?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
      tyreSize: dataFormAppointment?.tyreSize &&  dataFormAppointment?.tyreSize != "" ? dataFormAppointment?.tyreSize : "",
      orangeLightPilot:  dataFormAppointment?.orangeLightPilot ? dataFormAppointment?.orangeLightPilot : false,
      itvBonus: dataFormAppointment?.itvBonus ? dataFormAppointment?.itvBonus : false,
      originalDocItv:  dataFormAppointment?.originalDocItv ? dataFormAppointment?.originalDocItv : false,
      numberOfTyres: dataFormAppointment?.numberOfTyres ? dataFormAppointment?.numberOfTyres : 2,
      tyrePosition: dataFormAppointment?.tyrePosition ? dataFormAppointment?.tyrePosition : "Delantero",
      vehicleControl: dataFormAppointment?.vehicleControl ? dataFormAppointment?.vehicleControl : null,
      itvDocumentation: dataFormAppointment?.itvDocumentation ? dataFormAppointment?.itvDocumentation : false
    }
    
    dispatch(setFormAppointment({...dataFormAppointment,...preloadedFieldsWorkshopAppointment}));

    const preloadedFieldsDocumentation = {
      email: dataFormDocumentation?.email &&  dataFormDocumentation?.email != "" ? dataFormDocumentation?.email : contract.contractData?.email? contract.contractData.email : "",
      name: dataFormDocumentation?.name &&  dataFormDocumentation?.name != "" ? dataFormDocumentation?.name :  contract.contractData?.userName || "",
      surname : dataFormDocumentation?.surname &&  dataFormDocumentation?.surname != "" ? dataFormDocumentation?.surname : contract.contractData?.userSurnames || "",
      phoneNumber:  dataFormDocumentation?.phoneNumber &&  dataFormDocumentation?.phoneNumber != "" ? dataFormDocumentation?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
      dni: dataFormDocumentation?.dni &&  dataFormDocumentation?.dni != "" ? dataFormDocumentation?.dni : contract.contractData? contract.contractData?.licenseNumber : "",
      mtr: dataFormAppointment?.mtr ? dataFormAppointment?.mtr : false,
    }
    
    dispatch(setFormDocumentation({...dataFormDocumentation,...preloadedFieldsDocumentation}));
    dispatch(setFormResidentCard({...dataFormDocumentation,...preloadedFieldsDocumentation}));

    const preloadClaimsData = {
      name: dataFormClaims?.name && dataFormClaims?.name !== "" ? dataFormClaims.name : contract.contractData?.userName || "",
      surname: dataFormClaims?.surname && dataFormClaims?.surname !== "" ? dataFormClaims.surname : contract.contractData?.userSurnames || "",
      phoneNumber: dataFormClaims?.phoneNumber && dataFormClaims?.phoneNumber !== "" ? dataFormClaims.phoneNumber : contract.contractData?.mobilePhone || "",
      templateId: null,
      notes: dataFormClaims?.notes && dataFormClaims?.notes !== "" ? dataFormClaims.notes : contract.contractData?.notes || "",
      email: dataFormClaims?.email && dataFormClaims?.email?.trim() !== "" ? dataFormClaims.email : contract.contractData?.email ?? "",
      urgent: dataFormClaims?.urgent ?? false,
      workshopEntry: dataFormClaims?.workshopEntry ?? null,
      immobilizationReason: dataFormClaims?.immobilizationReason ?? "",
      immobilizationTime: dataFormClaims?.immobilizationTime ?? null,
      driveOn: contract.voChanel === "DRIVEON",
      subType: dataFormClaims?.subType ? dataFormClaims?.subType : contract.voChanel === "DRIVEON"? "factory_process_maintenance_claim_driveon" : null,
    }

    dispatch(setFormClaims({...dataFormClaims, ...preloadClaimsData}));

    const preloadDeliveryData = {
      name: preloadDeliveryData?.name && dataFormDelivery?.name !== "" ? dataFormDelivery.name : contract.contractData?.userName || "",
      surname: dataFormDelivery?.surname && dataFormDelivery?.surname !== "" ? dataFormDelivery.surname : contract.contractData?.userSurnames || "",
      phoneNumber: dataFormDelivery?.phoneNumber && dataFormDelivery?.phoneNumber !== "" ? dataFormDelivery.phoneNumber : contract.contractData?.mobilePhone || "",
      templateId: null,
      notes: dataFormDelivery?.notes && dataFormDelivery?.notes !== "" ? dataFormDelivery.notes : contract.contractData?.notes || "",
      email: dataFormDelivery?.email && dataFormDelivery?.email?.trim() !== "" ? dataFormDelivery.email : contract.contractData?.email ?? "",
    }

    dispatch(setFormDelivery({...dataFormDelivery, ...preloadDeliveryData}));

    const preloadedFieldsInformation = {
      email: dataFormInformation?.email &&  dataFormInformation?.email != "" ? dataFormInformation?.email : contract.contractData?.email? contract.contractData.email : "",
      name: dataFormInformation?.name &&  dataFormInformation?.name != "" ? dataFormInformation?.name :  contract.contractData?.userName || "",
      surname : dataFormInformation?.surname &&  dataFormInformation?.surname != "" ? dataFormInformation?.surname : contract.contractData?.userSurnames || "",
      phoneNumber:  dataFormInformation?.phoneNumber &&  dataFormInformation?.phoneNumber != "" ? dataFormInformation?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
      dni: dataFormInformation?.dni &&  dataFormInformation?.dni != "" ? dataFormInformation?.dni : contract.contractData? contract.contractData?.licenseNumber : "",
    }
    
    dispatch(setFormInformation({...dataFormInformation,...preloadedFieldsInformation}));

    const preloadedFieldsTerminations= {
      email: dataFormTerminations?.email &&  dataFormTerminations?.email != "" ? dataFormTerminations?.email : contract.contractData?.email? contract.contractData.email : "",
      name: dataFormTerminations?.name &&  dataFormTerminations?.name != "" ? dataFormTerminations?.name :  contract.contractData?.userName || "",
      surname : dataFormTerminations?.surname &&  dataFormTerminations?.surname != "" ? dataFormTerminations?.surname : contract.contractData?.userSurnames || "",
      phoneNumber:  dataFormTerminations?.phoneNumber &&  dataFormTerminations?.phoneNumber != "" ? dataFormTerminations?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
      dni: dataFormTerminations?.dni &&  dataFormTerminations?.dni != "" ? dataFormTerminations?.dni : contract.contractData? contract.contractData?.licenseNumber : "",
    }
    
    dispatch(setFormTerminations({...dataFormTerminations,...preloadedFieldsTerminations}));

    const preloadedFieldsSubstitutionVehicle= {
      email: dataFormSubstitutionVehicle?.email &&  dataFormSubstitutionVehicle?.email != "" ? dataFormSubstitutionVehicle?.email : contract.contractData?.email? contract.contractData.email : "",
      name: dataFormSubstitutionVehicle?.name &&  dataFormSubstitutionVehicle?.name != "" ? dataFormSubstitutionVehicle?.name :  contract.contractData?.userName || "",
      surname : dataFormSubstitutionVehicle?.surname &&  dataFormSubstitutionVehicle?.surname != "" ? dataFormSubstitutionVehicle?.surname : contract.contractData?.userSurnames || "",
      phoneNumber:  dataFormSubstitutionVehicle?.phoneNumber &&  dataFormSubstitutionVehicle?.phoneNumber != "" ? dataFormSubstitutionVehicle?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
      dni: dataFormSubstitutionVehicle?.dni &&  dataFormSubstitutionVehicle?.dni != "" ? dataFormSubstitutionVehicle?.dni : contract.contractData? contract.contractData?.licenseNumber : "",
    }
    
    dispatch(setFormSubstitutionVehicle({...dataFormSubstitutionVehicle,...preloadedFieldsSubstitutionVehicle}));
    
    const preloadedFieldsOvc = {
      email: dataFormOvc?.email &&  dataFormOvc?.email != "" ? dataFormOvc?.email : contract.contractData?.email? contract.contractData.email : "",
      name: dataFormOvc?.name &&  dataFormOvc?.name != "" ? dataFormOvc?.name :  contract.contractData?.userName || "",
      surname : dataFormOvc?.surname &&  dataFormOvc?.surname != "" ? dataFormOvc?.surname : contract.contractData?.userSurnames || "",
      phoneNumber:  dataFormOvc?.phoneNumber &&  dataFormOvc?.phoneNumber != "" ? dataFormOvc?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
      dni: dataFormOvc?.dni &&  dataFormOvc?.dni != "" ? dataFormOvc?.dni : contract.contractData? contract.contractData?.licenseNumber : "",
      date: dataFormOvc?.date? dataFormOvc?.date :  currentCase.caseId !== 0 ? convertToLocalTime(currentCase.creationDate) : dayjs().format()
    }

    dispatch(setFormOvc(
      {...dataFormOvc, ...preloadedFieldsOvc}));


    const preloadedFieldsItv = {
      email: dataFormItv?.email &&  dataFormItv?.email != "" ? dataFormItv?.email : contract.contractData?.email? contract.contractData.email : "",
      name: dataFormItv?.name &&  dataFormItv?.name != "" ? dataFormItv?.name :  contract.contractData?.userName || "",
      surname : dataFormItv?.surname &&  dataFormItv?.surname != "" ? dataFormItv?.surname : contract.contractData?.userSurnames || "",
      phoneNumber:  dataFormItv?.phoneNumber &&  dataFormItv?.phoneNumber != "" ? dataFormItv?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
      }

    dispatch(setFormItv({...dataFormItv, ...preloadedFieldsItv}));


    const preloadedFieldsFuelCard = {
      email: dataFormFuelCard?.email &&  dataFormFuelCard?.email != "" ? dataFormFuelCard?.email : contract.contractData?.email? contract.contractData.email : "",
      name: dataFormFuelCard?.name &&  dataFormFuelCard?.name != "" ? dataFormFuelCard?.name :  contract.contractData?.userName || "",
      surname : dataFormFuelCard?.surname &&  dataFormFuelCard?.surname != "" ? dataFormFuelCard?.surname : contract.contractData?.userSurnames || "",
      phoneNumber:  dataFormFuelCard?.phoneNumber &&  dataFormFuelCard?.phoneNumber != "" ? dataFormFuelCard?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
      dni: dataFormFuelCard?.dni &&  dataFormFuelCard?.dni != "" ? dataFormFuelCard?.dni : contract.contractData? contract.contractData?.licenseNumber : "",
    }

    dispatch(setFormFuelCard({...dataFormFuelCard, ...preloadedFieldsFuelCard}));

    const preloadedFieldsMarsh = {
      email: dataFormMarsh?.email &&  dataFormMarsh?.email != "" ? dataFormMarsh?.email : contract.contractData?.email? contract.contractData.email : "",
      name: dataFormMarsh?.name &&  dataFormMarsh?.name != "" ? dataFormMarsh?.name :  contract.contractData?.userName || "",
      surname : dataFormMarsh?.surname &&  dataFormMarsh?.surname != "" ? dataFormMarsh?.surname : contract.contractData?.userSurnames || "",
      phoneNumber:  dataFormMarsh?.phoneNumber &&  dataFormMarsh?.phoneNumber != "" ? dataFormMarsh?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
      dni: dataFormMarsh?.dni &&  dataFormMarsh?.dni != "" ? dataFormMarsh?.dni : contract.contractData? contract.contractData?.licenseNumber : "",
      sendMail: false
    }

    dispatch(setFormMarsh({...dataFormMarsh, ...preloadedFieldsMarsh}));

    setDataDocumentation(prevState => ({
        ...prevState,
        template:e
    }));    
  
  }

  useEffect(()=>{
        if(currentCase && documentationTemplates){
            let filteredOptions = documentationTemplates;
 
          if(currentCase.stateId === CaseStates.CLOSED){
                filteredOptions = documentationTemplates.filter((selectedTemplate)=>TemplatesAvaliableWithClosedCase.some(closedCaseTemplate=>selectedTemplate.code === closedCaseTemplate))
           }
            setTemplateOptions(filteredOptions)

            const selectBox = templateCombo?.current?.instance;
            selectBox?.reset()
        }          
  },[currentCase?.caseId, documentationTemplates])

  useEffect(()=>{
    if(!dataDocumentation.template){
      const selectBox = templateCombo?.current?.instance;
      selectBox?.reset()
      }
  },[dataDocumentation.template])


  useEffect(()=>{
    if(Object.keys(documentationTemplates).length == 0){  
      dispatch(getDocumentationTemplate());
      setDataDocumentation(prevState => ({
        ...prevState,
        template:null,
      }));
    }
  },[contract])

  useEffect(()=>{
    if(contract.caseStateId === CaseStates.CLOSED){
      setDisabledButtom({documentation: true})
    }
  },[contract.caseStateId])

    return (
      <PanelDialogue
        open={showDocumentation}
        showActionButtons={false}
        title={t("SmartTemplates")}
        anchorEl={anchorEl}
        cancelFunction={() => handleShowForms("documentation")}
      >
        <div style={{marginBottom: "1rem"}}>
          <SelectBox value={dataDocumentation.template} onValueChange={handleTemplateChange} searchEnabled innerRef={templateCombo} displayExpr="name" label={t("Templates")} labelMode={"floating"} dataSource={templateOptions}></SelectBox>
        </div>
         <Form 
            classes={classes}
            names={names}
            setNames={setNames}
            dataForm={getDataForm()} 
            setDataForm={getSetterPropertyDataForm()} 
            template={dataDocumentation.template} 
            disabledButtom={disabledButtom} 
            disableSubmit={dataDocumentation.template == null}
            submitForm={getSubmitFunction()}
            handleShowForms={handleShowForms}  
            type="documentation">
        </Form>
            <div style={{display: "flex", alignItems: "center", columnGap: "1rem", paddingTop: "1rem", paddingBottom:"1rem"}}>
        <Button 
          disabled={disabledButtom}
          color="primary"
          onClick={ () => handleShowForms("documentation")}
          variant="outlined"
          >
            {t("Cancel")}
          </Button>
          <div style={{flexGrow: 1, display: "flex", justifyContent: "flex-end"}}>
          {/* <Button 
            disabled={disabledButtom || dataDocumentation.template == null}
            color="primary"
            id={"draftButton"}
            onClick={()=>getSubmitFunction()(getDataForm(), names, true)}
            variant="outlined"
          >Borrador</Button> */}
        </div>
        <Button
          disabled={disabledButtom || dataDocumentation.template == null}
          color="primary"
          id={"submitButton"}
          onClick={()=>getSubmitFunction()(getDataForm(), names, false)}
          variant='contained'
        >{t("Send")}</Button>
      </div>   
      </PanelDialogue>
    );
 }